import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import ConditionIcons from 'features/Weather/components/ConditionIcons/ConditionIcons';
import useLocation from 'hooks/useLocation';
import { Container } from 'react-bootstrap';
import { WiDaySunny, WiMoonAltWaxingCrescent4 } from 'react-icons/wi';
import {
  useGetAstronomyDataQuery,
  useGetConditionsbyCityQuery,
} from 'services/weather/weather.api';
import WeatherCard from 'features/Weather/components/WeatherCard/WeatherCard';
import { weatherDetails } from '../../config/forecast.config';
import HourlyForecast from '../HourlyForecast/index.web';
import './assets/forecastHome.css';
import { moonDetails, sunDetails } from './config/forecastHome.config';
import {
  getCurrentCondition,
  getCurrentConditionTitle,
  hasMoonData,
  hasSunData,
} from './utils/forecastHome.utils';

const ForecastHome = () => {
  const { locations } = useLocation();
  const effectiveLocation = locations.effectiveLocation;
  const { data: currentConditions = [], isLoading: loadingCurrentConditions } =
    useGetConditionsbyCityQuery(effectiveLocation);
  const { data: astronomy, isLoading: loadingAstronomy } =
    useGetAstronomyDataQuery(effectiveLocation);
  const currentCondition = getCurrentCondition(currentConditions);

  return (
    <>
      {!loadingAstronomy && !loadingCurrentConditions ? (
        <Container
          fluid
          className="forecast-home d-flex flex-column h-100 gap-4 user-select-none px-0"
        >
          <div className="row g-4 forecast-home-overview-row">
            {currentCondition && (
              <div className="col col-12 col-xl-6 d-flex forecast-home-current-card">
                <WeatherCard
                  weatherObj={currentCondition}
                  title={getCurrentConditionTitle(currentCondition)}
                  headerIcon={
                    <ConditionIcons
                      conditionId={parseInt(currentCondition?.icon || '0', 10)}
                      size={25}
                    />
                  }
                  details={weatherDetails}
                />
              </div>
            )}
            {hasSunData(astronomy) && (
              <div className="col col-12 col-md-6 col-xl-3 d-flex forecast-home-astronomy-card forecast-home-sun-card">
                <WeatherCard
                  weatherObj={astronomy}
                  title="Sun"
                  headerIcon={<WiDaySunny size={25} />}
                  details={sunDetails}
                />
              </div>
            )}
            {hasMoonData(astronomy) && (
              <div className="col col-12 col-md-6 col-xl-3 d-flex forecast-home-astronomy-card forecast-home-moon-card">
                <WeatherCard
                  weatherObj={astronomy}
                  title="Moon"
                  headerIcon={<WiMoonAltWaxingCrescent4 size={25} />}
                  details={moonDetails}
                />
              </div>
            )}
          </div>
          <HourlyForecast />
        </Container>
      ) : (
        <WidgetLoadingAnimation />
      )}
    </>
  );
};

export default ForecastHome;
